import { Parser } from "@siteimprove/alfa-parser";
import { Keyword } from "../textual/keyword.js";
import { LengthPercentage } from "../numeric/index.js";
import { Side } from "./side.js";
const { either, map } = Parser;
/**
 * @public
 */
export var Component;
(function (Component) {
    function resolve(resolver) {
        return (value) => (Side.isSide(value) ? value.resolve(resolver) : value);
    }
    Component.resolve = resolve;
    function partiallyResolve(resolver) {
        return (value) => Side.isSide(value) ? value.partiallyResolve(resolver) : value;
    }
    Component.partiallyResolve = partiallyResolve;
    /**
     * Parses an isolated offset (length-percentage), and adds the provided default
     * side to make a Side.
     *
     * @internal
     */
    function parseOffset(side) {
        return map(LengthPercentage.parse, (value) => Side.of(side, value));
    }
    Component.parseOffset = parseOffset;
    // "center" is included in Side.parse[Horizontal, Vertical]
    /**
     * @internal
     */
    Component.parseHorizontal = either(parseOffset(Keyword.of("left")), Side.parseHorizontal);
    /**
     * @internal
     */
    Component.parseVertical = either(parseOffset(Keyword.of("top")), Side.parseVertical);
})(Component || (Component = {}));
//# sourceMappingURL=component.js.map